import { PartnerPageData } from 'types/types'

export const getCorrectMainFont = (page: PartnerPageData) => {
  if (page.company_domain.includes('starsports') || page.feature_flags.is_star_sports_page) {
    return 'Coluna Rounded'
  }
  return page.fonts.main_font.family ?? 'Montserrat, sans-serif'
}
